import './StatusBadge.css'

export default function StatusBadge({ tone = 'neutral', variant = 'default', className = '', children, ...props }) {
  return (
    <span
      {...props}
      className={`status-badge${variant !== 'default' ? ` status-badge--${variant}` : ''} is-${tone}${className ? ` ${className}` : ''}`}
      data-i18n-live="1"
    >
      {children}
    </span>
  )
}
